// extracted by mini-css-extract-plugin
export var bubble = "_3v-0";
export var container = "_3v-3";
export var contrastBorder = "_3v-4";
export var greyOut = "_3v-2";
export var initialsWrapper = "_3v-1";
export var large = "_3v-9";
export var medium = "_3v-8";
export var mediumSmall = "_3v-7";
export var mediumSmallMedium = "_3v-c";
export var micro = "_3v-5";
export var small = "_3v-6";
export var tiny = "_3v-b";
export var xTiny = "_3v-a";